__turbopack_context__.v({
  "content": "fold-module-scss-module____36HG__content",
  "date": "fold-module-scss-module____36HG__date",
  "devtool": "fold-module-scss-module____36HG__devtool",
  "dot": "fold-module-scss-module____36HG__dot",
  "draft": "fold-module-scss-module____36HG__draft",
  "env": "fold-module-scss-module____36HG__env",
  "gear": "fold-module-scss-module____36HG__gear",
  "icon": "fold-module-scss-module____36HG__icon",
  "open": "fold-module-scss-module____36HG__open",
  "pill": "fold-module-scss-module____36HG__pill",
  "previewInfo": "fold-module-scss-module____36HG__previewInfo",
  "published": "fold-module-scss-module____36HG__published",
  "surface": "fold-module-scss-module____36HG__surface",
});
